export const DEFAULT_MENTEE_QUESTION_ID = 'mentee_description_aspirations';
export const DEFAULT_MENTEE_QUESTION_LABEL =
  'Danos una pequeña descripción de a qué te dedicas y a qué aspiras';

export const createDefaultMenteeQuestion = () => ({
  id: DEFAULT_MENTEE_QUESTION_ID,
  type: 'long_text',
  label: DEFAULT_MENTEE_QUESTION_LABEL,
  helpText: '',
  placeholder: '',
  required: true,
  audience: 'mentee',
  options: [],
});

export const isDefaultMenteeQuestion = (question) =>
  question?.id === DEFAULT_MENTEE_QUESTION_ID;

// Preserve ordering and editable hints, but never change the system question's
// identity, audience, answer type or mandatory response requirement.
export const ensureDefaultMenteeQuestion = (questions = []) => {
  let included = false;
  const result = [];

  questions.forEach((question) => {
    if (!isDefaultMenteeQuestion(question)) {
      result.push(question);
      return;
    }
    if (included) return;
    included = true;
    result.push({
      ...question,
      ...createDefaultMenteeQuestion(),
      helpText: typeof question.helpText === 'string' ? question.helpText : '',
      placeholder:
        typeof question.placeholder === 'string' ? question.placeholder : '',
    });
  });

  return included ? result : [createDefaultMenteeQuestion(), ...result];
};
